﻿package com.mgacreative.hotelru.feature.guestapp.di

import com.mgacreative.hotelru.feature.guestapp.ui.GuestAppViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getGuestAppFeatureModule() = module {
    viewModel { GuestAppViewModel() }
}

